import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import { getSpajs } from '../../store/features/SPAJSlice'
import { getParameterApps } from '../../store/features/OTPSlice'
import { Row, Col } from 'react-bootstrap';
import { getAddDays } from '../../component/Helper'
import './thankyoustyles.css';
import { logOut } from '../../store/features/OTPSlice'
import cookie from 'js-cookie'

const Thankyou = () => {
    let navigate = useNavigate();
    const SPAJNumber = useParams();
    const { SPAJs } = useSelector((state) => state.SPAJs);
    const { DeviceId } = useSelector(state => state.DeviceId)
    const { Parameter } = useSelector((state) => state.Params);
    const [loadingSPAJ, setLoadingSPAJ] = useState(true);
    const [loadingParameter, setLoadingParameter] = useState(true);
    const [loading, setLoading] = useState(true);
    const [expired, setExpired] = useState(false);
    const [reject, setReject] = useState(false);
    const dispatch = useDispatch();

    useEffect(()=>{
        let data = {
            deviceid: `${DeviceId.deviceId}`,
            username: `${SPAJs.spajHeader?.userName}`,
            spajNumber: `${SPAJs.spajHeader?.spajNumber}`
        }
        dispatch(logOut(data)).then(res => {
            // if (res.status == "OK") {
            cookie.remove('accessToken');
            cookie.remove('refreshToken');
            localStorage.removeItem("SPAJ_HEADER");
            localStorage.removeItem("TOKEN");
            sessionStorage.removeItem('tokenPayment');
            navigate( "/" + localStorage.getItem("spajHash"));
            // } else {
            // alert("error logout");
            // }
        }).catch(err => {
            return err
        })
    },[])
    // useEffect(() => {
        // localStorage.setItem("spajHash", SPAJNumber.id);
        // setLoading(true);
        // if (SPAJNumber.id != null) {
        //     let tmpReq = {
        //         spajNumber: SPAJNumber.id
        //     }

        //     // GET DETAIL SPAJ HEADER
        //     dispatch(getSpajs(tmpReq)).then(res => {
        //         setLoadingSPAJ(false);
        //         localStorage.setItem("SPAJ_HEADER", JSON.stringify(res.payload.spajHeader));
        //     }).catch(err => {
        //         setLoadingSPAJ(false);
        //     })
        // }

        // GET SYSTEM PARAMETER=
    //     dispatch(getParameterApps()).then(res => {
    //         setLoadingParameter(false);
    //     }).catch(err => {
    //         setLoadingSPAJ(false);
    //     });
    // }, [])

    // const navigatePage = () => {
    //     // if (SPAJs.spajHeader.isLogin === "1") {
    //     // } else {
    //     navigate( '/otp');
    //     // }
    // }

    // useEffect(() => {
    //     if (!loadingParameter && !loadingSPAJ) {
    //         setLoading(false);

    //         // Check Expired Send Mail Date
    //         let sendMailDate = new Date(SPAJs.spajHeader?.SentMailDate);
    //         let expiredDateParam = Parameter.dataParameterApps.find(param => {
    //             if (param.codeSetting == "URL_EXPIRED")
    //                 return true;
    //         })
    //         let expiredMailDate = new Date(getAddDays(sendMailDate, expiredDateParam.valueSetting));
    //         let today = new Date();
    //         today.setHours(0, 0, 0, 0);

    //         if (today > expiredMailDate) {
    //             setExpired(true);
    //         }

    //         // Check Status Reject
    //         let status = SPAJs.spajHeader.statusCustomer;
    //         if (status == "RJC") {
    //             setReject(true);
    //         }
    //     }
    // }, [loadingSPAJ, loadingParameter])

    const ReturnData = () => {
        // if (SPAJNumber.id == null || SPAJs == null) {
        //     return (
        //         <>
        //             <div className='logo-posisi'>
        //                 <img src="/images/Logo-A-Stripes-White.png" width="130px" height="auto" />
        //             </div>
        //             <div className="card-container shadow-lg">
        //                 <div className='bold fs-16 text-center'>Selamat Datang!</div>
        //                 <div className='mt-2'>
        //                     <div className='fs-12 text-center'>Maaf SPAJ Number yang anda masukan tidak tersedia</div>
        //                 </div>
        //             </div>

        //            { /* <div className="card-container shadow-lg">
        //                 <div className='bold fs-16 text-center'>Terima Kasih atas kepercayaan Anda telah memilih Generali Indonesia</div>
        //                 <div className='mt-2'>
        //                     <div className='fs-12 text-center'>Surat Pengajuan Asuransi Jiwa Anda (SPAJ) dengan No xxx sedang dalam proses.</div>
        //                 </div>
        //                 <div className='mt-2'>
        //                     <div className='fs-12 text-center'>Silahkan menghubungi Agen Anda untuk mendapatkan informasi status pengajuan selanjutnya.</div>
        //                 </div>
        //                 </div> */}
        //         </>
        //     )
        // }

        // if (reject) {
        //     return (
        //         <>
        //             {
        //                 SPAJs.spajHeader.gender == "M" ? (
        //                     <>
        //                         <div className="card-container shadow-lg">
        //                             <div className='bold fs-16 text-center'>Bapak {SPAJs.spajHeader.firstName} No SPAJ {SPAJs.spajHeader.spajNumber}</div>
        //                             <div className='mt-2'>
        //                                 <div className='fs-12 text-center'>Pengajuan Asuransi Jiwa Anda sedang dalam proses perubahan data, mohon menghubungi Agen Anda untuk update terkini.</div>
        //                             </div>
        //                         </div>
        //                     </>
        //                 ) : (
        //                     <>
        //                         <div className="card-container shadow-lg">
        //                             <div className='bold fs-16 text-center'>Ibu {SPAJs.spajHeader.firstName} No SPAJ {SPAJs.spajHeader.spajNumber}</div>
        //                             <div className='mt-2'>
        //                                 <div className='fs-12 text-center'>Pengajuan Asuransi Jiwa Anda sedang dalam proses perubahan data, mohon menghubungi Agen Anda untuk update terkini.</div>
        //                             </div>
        //                         </div>
        //                     </>
        //                 )
        //             }
        //         </>
        //     )
        // }

        // if (expired) {
        //     return (
        //         <>
        //             <div className="card-container-welcome shadow-lg">
        //                 <div className='bold fs-16 text-center'>Selamat Datang!</div>
        //                 <div className='mt-2'>
        //                     <div className='fs-12 text-center'>Maaf Link anda telah expired</div>
        //                 </div>
        //             </div>
        //         </>
        //     )
        // }

        return (
            <>
                <div className='logo-posisi'>
                    <img src="/images/generali-white.png" className='size-logo' />
                </div>
                <div className='position-cardfooter'>
                    <div className="card-container-welcome shadow-lg">
                        <div className='bold fs-16 text-center'>Terima Kasih</div>
                        {/* <div className='mt-2'>
                            <div className='bold text-red fs-16 text-center'>{SPAJs?.spajHeader?.firstName}</div>
                            <div className='bold text-red fs-16 text-center'>SPAJ {SPAJs?.spajHeader?.spajNumber}</div>
                        </div> */}
                        <div className='mt-2'>
                            <div className='fs-12 text-center'>Atas kepercayaan Anda telah memilih Generali Indonesia. <br/>
                            Surat Pengajuan Asuransi Jiwa Anda (SPAJ) dengan No {SPAJs.spajHeader?.spajNumber} sedang dalam Proses <br/>
                            Silakan menghubungi Agen Anda untuk mendapatkan informasi status pengajuan selanjutnya.</div>
                        </div>
                        {/* <div className='mt-2'>
                            <button className='button-red' onClick={() => navigatePage()}>Masuk</button>
                        </div> */}
                    </div>
                    <div className='logo-link'>
                        <div>www.generali.co.id</div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            {/* <LoadingOverlay active={loading} text="Loading..." spinner> */}
            <div>
                <Row className="g-0 welcome-container">
                    <Col xs={12} sm={12} md={12} lg={6}>
                        <div className="left-container position-relative">
                            <div className="icon-container">
                                <img src="/images/generali-white.png" className="icon-gen size-logo" />
                            </div>
                            <ReturnData />
                        </div>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6}>
                        <div className='logo-posisi-potrait'>
                            <img src="/images/header2.png" className='size-logo' />
                        </div>
                        <div>
                            <img src="/images/loginpage.jpg" className="ilustration thankyouImg"  />
                        </div>
                    </Col>
                </Row>
            </div>
            {/* </LoadingOverlay> */}
        </>
    )


}

export default Thankyou;